<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss"></style>
<template>
  <div style="display: flex;width: 100%;height: 473px;">
    <el-tabs tab-position="left">
      <el-tab-pane :label="$t('zongtishezhi')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t("kanbanfengge") }}
          </p>
        </div>
        <div>
          <el-radio v-model="monitorSetting.MONITOR_MANUFACTURING_TEMPLATE" label="black">{{ $t("heise") }}</el-radio>
          <el-radio v-model="monitorSetting.MONITOR_MANUFACTURING_TEMPLATE" label="blue">{{ $t("lanse") }}</el-radio>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('qitaxinxi')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t("kanbanbiaoti") }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;width: 500px">
          <!--          @input="updateInput"-->
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['MONITOR_MANUFACTURING_HEADER_' + store.state.customer.id]"></el-input>
          <div style="margin-left: 10px">-</div>
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['MONITOR_MANUFACTURING_CARD_TITLE_' + store.state.customer.id]"></el-input>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_manufacturing_setting",
  components: {},

  data() {
    return {
      monitorSetting: {},
    };
  },
  created() {
    this.resetData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() { },
  methods: {
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem("MONITOR_SETTING");
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
      //每个单独初始化可以进行增量初始化，而不是一整个setting初始化
      this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE = this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE != null ? this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE : "black";
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 500);
    },
    save() {
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit("SetManufacturingTemplate");
    },
  },
};
</script>
